import React, { useEffect, useState } from "react";
import { SelectInput } from "asocomponents"

function SelectEtapa({ onChange, width, valor }) {

  const [isUserMedico, setIsUserMedico] = useState()
  const [isUserTecnico, setIsUserTecnico] = useState()
  const [isUserLetrado, setIsUserLetrado] = useState()

  let data = []

  if (isUserLetrado) {
    data = [
      { idEtapa: "I", descripcion: "Inicial" },
      { idEtapa: "F", descripcion: "Final" },
      { idEtapa: "R", descripcion: "Recurso Corte" }
    ]
  } else if (isUserMedico) {
    data = [
      { idEtapa: "J", descripcion: "Junta Médica" },
      { idEtapa: "A", descripcion: "Impugnación/Asistencia Pericia" },
      { idEtapa: "P", descripcion: "Puntos Pericia" }
    ]
  } else if (isUserTecnico) {
    data = [
      { idEtapa: "E", descripcion: "Envío documental" },
      { idEtapa: "G", descripcion: "Impugnación pericia" },
      { idEtapa: "N", descripcion: "Nueva demanda" },
      { idEtapa: "T", descripcion: "Perito responde" }
    ]
  }

  useEffect(() => {
    const usuario = sessionStorage.getItem('usuario')
    if (usuario) {
      const parsed = JSON.parse(usuario)
      setIsUserMedico(parsed.isUserMedico)
      setIsUserTecnico(parsed.isUserTecnico)
      setIsUserLetrado(parsed.isUserLetrado)
    }
  }, [])

  return (
    <div>
      <SelectInput options={data} placeholder="Seleccionar" todos={false} onChange={onChange} defaultValue={valor || "-2"} width={width} valueField="idEtapa"></SelectInput>
    </div>
  )
}

export default SelectEtapa